import { render, staticRenderFns } from "./coachSelect.vue?vue&type=template&id=23a6534e&scoped=true&"
import script from "./coachSelect.vue?vue&type=script&lang=js&"
export * from "./coachSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a6534e",
  null
  
)

export default component.exports